import type { GameId, RoomCode } from '@pixelworld/shared';
import { Button } from '../../components/Button';
import { da } from '../../i18n/da';
import { usePublicRooms } from './usePublicRooms';
import styles from './PublicRoomList.module.css';

interface PublicRoomListProps {
  gameId: GameId;
  onEnter: (code: RoomCode) => void;
}

/** Open rooms anyone can walk into. Only the player count is shown, never names. */
export function PublicRoomList({ gameId, onEnter }: PublicRoomListProps) {
  const rooms = usePublicRooms(gameId);

  return (
    <section className={styles.list} aria-labelledby="open-rooms-title">
      <h3 id="open-rooms-title" className={styles.title}>
        {da.start.openRooms}
      </h3>
      {rooms.length === 0 ? (
        <p className={styles.empty}>{da.start.noOpenRooms}</p>
      ) : (
        <ul className={styles.rooms}>
          {rooms.map((room) => (
            <li key={room.code} className={styles.room} data-testid="open-room">
              <span className={styles.code}>{room.code}</span>
              <span className={styles.count}>
                {da.start.roomPlayers(room.playerCount, room.maxPlayers)}
              </span>
              <Button size="small" variant="secondary" onClick={() => onEnter(room.code)}>
                {da.start.enterRoom}
              </Button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
